import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import Logo from "../../../static/assets/img/logo.png";
import ReactFlagsSelect from 'react-flags-select';
import 'react-flags-select/scss/react-flags-select.scss';
import i18n from '../../../i18n';
import {withTranslation} from 'react-i18next';
import {setLanguage} from '../../../redux/actions/language-detector/LanguageDetector';
import {getUserSubStatus} from '../../../redux/actions/sub-status/index';
import { sendOtp } from '../../../redux/actions/send-otp';
import {  otpVerified } from '../../../redux/actions/otp-verify';
import {  signUp  } from '../../../redux/actions/signup/index';
import { subscription } from "../../../route";


class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            close: false,
            phone: '',
            msisdn: '',
            sub_status: '',
            form_field: 'reg',
            otp: '',
            message: ''
        }
    }


    btnModalAddClass = () => {

        this.setState({
                close: true
            }
        )
    };

    btnModalRemoveClass = () => {

        this.setState({
                close: false
            }
        )
    };

    async componentDidMount(){
        i18n.changeLanguage('bd');
        await this.props.dispatch(setLanguage('bd'));
        await this.props.dispatch(getUserSubStatus());

        const { user_sub_status } = this.props;
        if(user_sub_status !== null){
            this.setState({
                msisdn: user_sub_status.data.msisdn,
                sub_status: user_sub_status.data.sub_status
            })
            localStorage.setItem('subInfo', JSON.stringify(user_sub_status.data));
        }
    }

    onSelectFlag = (d) => {
        i18n.changeLanguage(d.toLowerCase());
        this.props.dispatch(setLanguage(d.toLowerCase()));
    };

    handleChange = (event) => {
        this.setState({phone: event.target.value});
    };

    handleOTPChange = (event) => {
        this.setState({otp: event.target.value});
    };
    
    handleRegSubmit =  async(event) => {
        event.preventDefault();
        // await this.props.dispatch(signUp(this.state.phone));

        const { phone } = this.state;
        if(phone.length !== 11){
             alert('Invalid phone number')
             this.setState({
                phone: '',
                form_field: 'reg'
            })
        }else{
            await this.props.dispatch(sendOtp(this.state.phone));
            this.setState({
                phone: '',
                form_field: 'otp'
            })
        }

    };

    handleOTPSubmit =  async(event) => {
        event.preventDefault();
        if(this.state.otp.length === 4){
            await this.props.dispatch(otpVerified(this.props.send_opt.data.msisdn,this.state.otp));
            if(this.props.otp_verify.data.status === 'failed'){
                this.setState({
                    otp: '',
                    form_field: 'wrong_otp'
                })
            }else{
                window.location = '/'
            }
        }else{
            alert('Invalid OTP')
            this.setState({
                otp: '',
                form_field: 'otp'
            })
           
        }
        
        
       
    }

    handleWrongOTPSubmit =  (event) => {
        event.preventDefault();
        // await this.props.dispatch(signUp(this.state.phone));
        this.setState({
            phone: '',
            form_field: 'otp'
        })
    }

    render() {

        const {t, signup } = this.props;
        const {msisdn, sub_status, close, form_field } = this.state;
        var prevScrollpos = window.pageYOffset;
        window.onscroll = function () {
            var currentScrollPos = window.pageYOffset;
            if (prevScrollpos > currentScrollPos) {
                document.getElementById("header").style.top = "0";
            } else {
                document.getElementById("header").style.top = "-96px";
            }
            prevScrollpos = currentScrollPos;
        };
        return (

            <header className="header" id="header" style={{
                transition: "top 0.3s",
                position: "sticky",
                zIndex: "1",
                background: "#fff",
                boxShadow: "0px 4px 6px 0px rgba(12, 0, 46, 0.06)"
            }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <nav className="navbar navbar-expand-lg">
                                <Link to={"/"} className="navbar-brand logo">

                                    <img src={Logo} alt="logo"/>
                                </Link>
                                <button className="navbar-toggler" type="button" data-toggle="collapse"
                                        data-target="#main_menu" aria-controls="main_menu"
                                        aria-expanded="false">
                                    <span className="navbar-toggler-icon"></span>
                                </button>

                                <div className="collapse navbar-collapse main_menu" id="main_menu">
                                    <ul className="navbar-nav ml-auto">
                                        <li className="nav-item active">
                                            <Link to={"/"} className="nav-link">{t('header.home')}</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to={"/about"} className="nav-link">{t('header.about')}</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to={"/program"} className="nav-link">{t('header.program')}</Link>
                                        </li>
                                        <li className="nav-item">
                                            <Link to={"/contact"} className="nav-link">{t('header.contact')}</Link>
                                        </li>
                                        <li className="nav-item sub_btn">
                                            {(msisdn === 'NO_MSISDN' && sub_status === 0) ? 
                                                <li className="nav-item sub_btn">
                                                    <button className="nav-link" onClick={() => this.btnModalAddClass()}>{t('header.signup')}</button>
                                                </li> : 
                                            sub_status === 1 ? 
                                                <Link to={subscription} className="nav-link">{t('header.subscribe')}</Link>
                                                : null}
                                        </li>
                                        

                                        <li>
                                            <ReactFlagsSelect
                                                defaultCountry="BD"
                                                countries={["US", "BD"]}
                                                customLabels={{"US": "EN-US", "BD": "BANGLA"}}
                                                placeholder="Select Language"
                                                showSelectedLabel={false}
                                                alignOptions="right"
                                                disabled={false}
                                                onSelect={this.onSelectFlag}/>
                                        </li>

                                        <div className={close ? "modalBodySignUp modalBodyOpenSignUp" : "modalBodySignUp"}>
                                            <div className="modalContentSignUp">
                                                <p style={{textAlign: "right"}}> 
                                                    <span className="closeBtn" onClick={() => this.btnModalRemoveClass()} >X</span>
                                                </p>
                                                {form_field === 'reg' ? <Fragment>
                                                    <p>Get 1 month free access</p>
                                                    <form onSubmit={this.handleRegSubmit}>   
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" value={this.state.phone}  onChange={this.handleChange} placeholder="Please enter your mobile number"/>
                                                        </div>
                                                        <div className="form-group">
                                                            <button type="submit" className="btn btn-success">
                                                                Signup
                                                            </button>
                                                        </div>
                                                    </form>
                                                </Fragment> : form_field === 'otp' ? <Fragment>
                                                <p>Enter OTP</p>
                                                    <form onSubmit={this.handleOTPSubmit}>   
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" value={this.state.otp}  onChange={this.handleOTPChange} placeholder="xxxx"/>
                                                        </div>
                                                        <div className="form-group">
                                                            <button type="submit" className="btn btn-success">
                                                                Verify
                                                            </button>
                                                        </div>
                                                    </form>
                                                </Fragment>:<Fragment>
                                                <p>Wrong OTP!!! Please Enter Correct OTP</p>
                                                    <form onSubmit={this.handleOTPSubmit}>   
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" value={this.state.otp}  onChange={this.handleOTPChange} placeholder="xxxx"/>
                                                        </div>
                                                        <div className="form-group">
                                                            <button type="submit" className="btn btn-success">
                                                                Verify Again
                                                            </button>
                                                        </div>
                                                    </form>
                                                </Fragment> }
                                            </div>
                                        </div>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

const mapStateToProps = (state) => ({
    language_detector: state.language_detector,
    user_sub_status: state.user_sub_status,
    signup: state.signup,
    send_opt: state.send_opt,
    otp_verify: state.otp_verify
});

export default withTranslation()(connect(mapStateToProps)(Header));